import { sampleSizeBand, sampleSizeNote } from '../../shared/sample-size.ts';

export function SampleBadge(props: { n: number }) {
  const band = sampleSizeBand(props.n);
  const styles = {
    strong: 'border-line text-muted',
    moderate: 'border-line text-muted',
    small: 'border-warn/40 text-warn',
    very_small: 'border-warn/60 bg-warn/10 text-warn',
  } as const;
  return (
    <span
      className={`inline-flex rounded border px-1.5 py-0.5 text-[10px] uppercase tracking-wide ${styles[band]}`}
      title={sampleSizeNote(props.n)}
    >
      {band === 'strong'
        ? 'Strong sample'
        : band === 'moderate'
          ? 'Moderate sample'
          : band === 'small'
            ? 'Small sample'
            : 'Very small sample'}
    </span>
  );
}
